import { Route, Routes, Navigate } from 'react-router-dom';
import { useAdminContext } from './context';
import { AdminLayout } from './AdminLayout.jsx';

export default function AdminDashboard() {
  const context = useAdminContext();

  return (
    <AdminLayout>
      <Routes>
        <Route path="/" element={<Navigate to="/admin/lookup" replace />} />
        {context.routes.flatMap(buildRoute)}
      </Routes>
    </AdminLayout>
  );

  function buildRoute(routeConfig) {
    const { component: Component, ...passThrough } = routeConfig;

    return routeConfig.children
      ? routeConfig.children.map(buildRoute)
      : [
          <Route
            key={routeConfig.path}
            {...passThrough}
            element={<Component />}
          />,
        ];
  }
}
